import React from 'react';

const ReCaptchaNotice = () => (
  <p className="recaptcha-notice">
    Este sitio está protegido por reCAPTCHA.
    <br />
    <a
      href="https://policies.google.com/privacy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacidad
    </a>
    {' · '}
    <a
      href="https://policies.google.com/terms"
      target="_blank"
      rel="noopener noreferrer"
    >
      Términos
    </a>
    {' de Google.'}
  </p>
);

export default ReCaptchaNotice;
